export enum PrepaymentStatus {
    PrepaymentCompleted = 'prepayment_completed',
    PartpaymentCompleted = 'partpayment_completed'
}